import React from "react";
import "./Footer.css";

export function Footer() {
    return (
        <footer class="footer-container">
      <span class="footer-span">
        © Pablo Augusto Correa Causa | Food PI
      </span>
        </footer>
    );
}